import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, InputAdornment } from '@mui/material';
import DialogComponent from '../../component/dialog/dialog.component';
import CommonInput from '../../component/form/common-input.component';
import i18n from '../../i18n';
import type { MenuLibraryManagementState } from './menu-library-management-state';
import { ReactComponent as SearchTitleIcon } from '../../static/images/svg/ic_round-search.svg';
import './scss/menu-library-dish-search-dialog.style.scss';

type Props = {
    state: MenuLibraryManagementState;
};

/**
 * 菜单库详情 — 搜索菜品弹窗（Figma 3424:35387）
 */
export const MenuLibraryDishSearchDialog: React.FC<Props> = observer(({ state }) => {
    return (
        <DialogComponent
            className="menu-library-dish-search-dialog__dialog-root"
            open={state.isDishSearchDialogOpen}
            onClose={() => state.closeDishSearchDialog()}
            maxWidth={false}
            PaperProps={{
                sx: {
                    width: 'min(560px, 92vw)',
                    maxWidth: '560px',
                    margin: '16px auto',
                    background: '#ffffff',
                    backgroundColor: '#ffffff',
                    border: '2px solid var(--fill-primary-300)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                },
            }}
            sx={{
                '& .MuiDialog-container > .MuiPaper-root': {
                    background: '#ffffff',
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    overflow: 'hidden',
                },
                '& .MuiDialogTitle-root': {
                    backgroundColor: '#ffffff',
                },
                '& .MuiDialogContent-root': {
                    paddingTop: '12px',
                    paddingBottom: '24px',
                    backgroundColor: '#ffffff',
                },
                '& .MuiDialogActions-root.dialog-footer': {
                    display: 'none',
                },
            }}
            defaultHeaderProps={{
                title: i18n.t('menu_library_search_dialog_title'), 
                onClose: () => state.closeDishSearchDialog(),
            }}
        >
            <Box className="menu-library-dish-search-dialog">
                <CommonInput
                    inputType="INPUT"
                    hiddenLabel
                    fullWidth
                    size="medium"
                    autoFocus
                    className="menu-library-dish-search-dialog__field"
                    value={state.dishSearchKeyword}
                    placeholder={i18n.t('menu_library_search_dialog_placeholder')}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        state.setDishSearchKeyword(e.currentTarget.value)
                    }
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchTitleIcon
                                    style={{
                                        width: 22,
                                        height: 22,
                                        color: 'var(--fill-primary-300)',
                                        display: 'block',
                                    }}
                                    aria-hidden
                                />
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        </DialogComponent>
    );
});
